import { Photo } from "pexels";
import { useTranslation } from "react-i18next";

function PexelsImage({
  data,
  selected = false,
  onImageClick = (image: Photo) => {},
}: {
  data: Photo;
  selected: boolean;
  onImageClick: (image: Photo) => void;
}) {
  const { t } = useTranslation();
  const backLink = `${data.url}`;

  return (
    <div
      className={`relative h-48 w-1/2 overflow-hidden rounded-sm border-4 ${
        selected ? "border-blue-500" : "border-white"
      }`}
    >
      <img
        src={data.src.medium}
        alt={data.alt || t("image_picker_pexels_alt")}
        className="w-full cursor-pointer object-cover"
        onClick={() => {
          onImageClick(data);
        }}
      ></img>
      <a
        className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 p-2 text-xs text-white"
        href={backLink}
        target="_blank"
        rel="noreferrer"
      >
        {t("image_picker_photo_by", { name: data.photographer })}{" "}
        <span className="font-bold">Pexels</span>
      </a>
    </div>
  );
}

export default PexelsImage;
